import { getDeviceName } from './utils/deviceUtils';

export const applicationConstants = {
  DEVICE_ID: '153811a6-c87e-4db6-b9a8-2cdb4a6f8cbe',
  DEVICE_NAME: getDeviceName(),
  LOW_BANDWIDTH: '208042',
  MEDIUM_BANDWIDTH: '272024',
  HIGH_BANDWIDTH: '3302024',
  IOS_USER_PAYMENT_LABEL: 'App Store Billing',
  UPDATE_ACKNOWLEDGE: 'updateAcknowledge',
  ACKNOWLEDGE_CANCEL_REMAIDER: 'acknowledgeSubCancelRemainder',
  ACKNOWLEDGE_CANCEL_REMAIDER_DATE: 'acknowledgeSubCancelRemainderDate',
  ATTRIBUTE_ACCOUNT: 'Account',
  //------------------------//
  API_AUTHORIZATION: 'Basic YWRtaW46cGFzc3dvcmQ=',
  API_KEY: '317832e1-ab61-43a0-89cf-50a9dcc635cf',
  API_SECRET: 'Iyy2lPCh80G9dfGkuCHc7_Ub5ZGCC4Ggzcz3Gcbg9tE',
  IAM_API_KEY: 't8V5auQJfRIWZIIetcY0rstz2IH4tsBWvXtfCr-CctiqRe9BCGk65a4P',
  API_ENDPOINT: 'https://bimps.ahapoc.firstlight.ai/1.0/kb/',
  IAM_ENDPOINT: 'https://iam.ahapoc.firstlight.ai/',
  PAYU_KEY: 'fkSS8s',
  PAYU_SALT: 'ox6wCMOP',
  // Tizen App service ID
  TIZEN_BG_SERVICE_ID: 'Sf1P8YsDLG.service',
  // Tizen appId
  TIZEN_APP_ID: 'Sf1P8YsDLG.ahaapp',
  TIZEN_MSG_PORT_NAME: 'FOREGROUND_APP_PORT',
  PERSONALISATION_TAGS: [
    'continue_watching',
    'because_you_watched',
    'favorite',
  ],
  DOLBY_ATMOS: 'DolbyAtmos',
  EAC3_JOC: 'eac3-joc',
  EAC3: 'eac3',

  APP_TYPE: 'tv',
  LG_DEVICE_NAME: 'lgwebostv',
  SAMSUNG_DEVICE_NAME: 'samsungtizentv',
  DMA_ID: '001',
  EVERGENT_TRUE: 'T',
};
